import React from 'react';
import './SanctionsPanel.css';

/**
 * Component for displaying active player sanctions (yellow/red cards)
 */
const SanctionsPanel = ({
    activeSanctions = [],
    homeTeamName,
    awayTeamName,
    getRemainingTime,
    getFormattedRemainingTime,
    isInWarningState
  }) => {
    // If no active sanctions, don't render anything
    if (!activeSanctions || activeSanctions.length === 0) {
      console.log('No active sanctions to display');
      return null;
    }

    console.log(`Rendering ${activeSanctions.length} active sanctions`);
    
    // Ensure all required props are available
    if (!getRemainingTime || !getFormattedRemainingTime || !isInWarningState) {
      console.error('Missing required props for SanctionsPanel');
      return null;
    }

    return (
      <div className="sanctions-panel">
        <div className="sanctions-header">
          SANCTIONS ({activeSanctions.length})
        </div>
        
        <div className="sanctions-list">
          {activeSanctions.map(sanction => {
            // Skip invalid sanctions
            if (!sanction || !sanction.id || !sanction.team || !sanction.cardType) {
              console.warn('Invalid sanction object:', sanction);
              return null;
            }
            
            return (
              <div
                key={sanction.id}
                className={`sanction-item ${sanction.team.toLowerCase()} ${
                  isInWarningState(sanction) ? 'warning' : ''
                }`}
              >
                <span className="sanction-icon">
                  {sanction.cardType === 'Yellow' ? '🟨' : '🟥'}
                </span>
                
                <span className="sanction-team">
                  {sanction.team === 'Home' ? homeTeamName : awayTeamName}
                </span>
                
                <span className="sanction-time">
                  {getFormattedRemainingTime(sanction)}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

export default SanctionsPanel;